export default {
  computed: {},
  methods: {
    singularPlural(word, singular) {
      if (singular) return word
      return word + 's'
    },
    teamVsPlayerWording(singles, plural, capital) {
      if (singles) {
        if (plural && capital) {
          return 'Players'
        } else if (plural) {
          return 'players'
        } else if (capital) {
          return 'Player'
        } else {
          return 'player'
        }
      } else {
        if (plural && capital) {
          return 'Teams'
        } else if (plural) {
          return 'teams'
        } else if (capital) {
          return 'Team'
        } else {
          return 'team'
        }
      }
    },
  },
}
